import { Box } from '@mui/material'
import { CustomStyles, getStyles } from '@utils/styles'
import defaultStyles, { StylesClassNames } from './styles'

type Props = {
  text: string
  csx?: CustomStyles<StylesClassNames>
}

export function HighlightedText({ text, csx }: Props) {
  const styles = getStyles<StylesClassNames>(defaultStyles, csx)
  return (
    <Box component="span" {...styles('wrapper')}>
      <Box component="span" {...styles('typo')}>
        {text}
      </Box>
    </Box>
  )
}
